import { apiGetBankTransactions } from "api/reportApi";
import TableSelect from "components/Input/tableSelect";
import Table from "components/Table";
import TableBalanceComp from "../TableBalanceComp";
import { useSelector } from "react-redux";
import { useAppDispatch, useAppSelector } from "store/store";
import useDateState from "helpers/useDateState";
import useCurrency from "helpers/useCurrency";
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Card, Header } from "../TablePrintTopComp";

export default function BankTransactions() {
  const dispatch = useAppDispatch();
  const { fromDate, toDate } = useDateState();
  const { defCur } = useCurrency();
  const [searchParams] = useSearchParams();
  const store = useAppSelector((state) => state);
  const [state, setState] = useState<FinancialPrintCompProps>({});
  const bank: Finance = (store.reportReducer as any)?.bank;
  const token: string = store.businessReducer.business.token;
  const [bankId, setBankId] = useState(searchParams.get("bankId"));
  const [tab, setTab] = useState("");

  function handleChange(options: any) {
    let data: any = {};
    if (fromDate && toDate) {
      data.searchText = fromDate;
      data.searchTextAlt = toDate;
      data.subColumn = "date";
    }
    setTab(options?.activeTab?.apiKey ? options?.activeTab?.apiKey : '')
    dispatch(
      apiGetBankTransactions({
        pagination: options?.paginationState,
        id: bankId,
        options: data,
        search: options?.paginationState?.search,
        sort: options?.paginationState?.sort,
        tab: options?.activeTab?.apiKey,
        token,
        

      })
    );
  }
  return (
    <div className="wrap-journal">
      <Table
        type="bankTransactions"
        middleComp={
          <TableSelect
            entity="bank"
            type="bankTransactions"
            refetch={apiGetBankTransactions}
            activeTab={tab}
            onChange={(val, financial, dates) => {
              setBankId(val)
              setState({ financial, dates, balance: `${Intl.NumberFormat().format(bank?.balance || 0)} ${bank?.Currency?.en_title || defCur.en_title}` })
            }}
          />
        }
        onTabChange={handleChange}
        titleSection={
          <TableBalanceComp
            title="مانده حساب"
            currency={bank?.Currency?.en_title || defCur.en_title}
            balance={bank?.balance}
          />
        }
        printComp={FinancialPrintComp(state)}
      />
    </div>
  );
}


interface FinancialPrintCompProps {
  financial?: any;
  dates?: any;
  balance?: any
}

function FinancialPrintComp(props: { financial?: any; dates?: any, balance?: any }) {
  const financial = props.financial || {};
  const toDate = props.dates?.toDate;
  const fromDate = props.dates?.fromDate;
  const RD = toDate && fromDate ? `گزارش ازتاریخ :${fromDate} تا تاریخ :${toDate}` : "گزارش برای کل سال مالی";
  const name = financial.name ? `گردش حساب ${financial.name}` : "";
  const remaining = props.balance || ""
  const totalRemaining = `مانده حساب : ${remaining}`
  return (
    <div>
      <Header texts={[RD, name, totalRemaining]} />
    </div>
  );
}